/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The NftGeneratorControllerDtoRemoveNftKeyIndexRequest model module.
 * @module model/NftGeneratorControllerDtoRemoveNftKeyIndexRequest
 * @version 1.0
 */
class NftGeneratorControllerDtoRemoveNftKeyIndexRequest {
    /**
     * Constructs a new <code>NftGeneratorControllerDtoRemoveNftKeyIndexRequest</code>.
     * @alias module:model/NftGeneratorControllerDtoRemoveNftKeyIndexRequest
     */
    constructor() { 
        
        NftGeneratorControllerDtoRemoveNftKeyIndexRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>NftGeneratorControllerDtoRemoveNftKeyIndexRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/NftGeneratorControllerDtoRemoveNftKeyIndexRequest} obj Optional instance to populate.
     * @return {module:model/NftGeneratorControllerDtoRemoveNftKeyIndexRequest} The populated <code>NftGeneratorControllerDtoRemoveNftKeyIndexRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new NftGeneratorControllerDtoRemoveNftKeyIndexRequest();

            if (data.hasOwnProperty('shape')) {
                obj['shape'] = ApiClient.convertToType(data['shape'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>NftGeneratorControllerDtoRemoveNftKeyIndexRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>NftGeneratorControllerDtoRemoveNftKeyIndexRequest</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['shape'] && !(typeof data['shape'] === 'string' || data['shape'] instanceof String)) {
            throw new Error("Expected the field `shape` to be a primitive type in the JSON string but got " + data['shape']);
        }

        return true;
    }


}



/**
 * @member {String} shape
 */
NftGeneratorControllerDtoRemoveNftKeyIndexRequest.prototype['shape'] = undefined;






export default NftGeneratorControllerDtoRemoveNftKeyIndexRequest;

